import styled from 'styled-components';

import { Anchor } from '@zillow/constellation';

export const StyledAnchor = styled(Anchor)`
    font-weight: 600;
`;
